var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOrigamiFlower(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 61.05,
    height: 59.14,
    viewBox: "0 0 61.05 59.14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1",
    transform: "translate(-4.747 -4.77)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M182.311,5.27c6.917,0,11.251,5.74,11.251,11.954s-3.63,13.361-11.251,18.989c-7.621-5.628-11.251-12.971-11.251-18.989,0-6.213,4.333-11.954,11.251-11.954Z",
    transform: "translate(-147.04 0)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M299.978,134.3c2.139,6.578-1.983,12.475-7.892,14.394s-13.829.676-21.536-4.832c3-8.987,8.86-14.708,14.584-16.568,5.91-1.92,12.709.427,14.846,7.006Z",
    transform: "translate(-235.279 -107.651)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M276.453,303.924c-5.6,4.065-12.476,1.969-16.128-3.058s-4.917-12.943-2.06-21.976c9.473.074,16.727,3.881,20.263,8.75,3.653,5.027,3.52,12.219-2.075,16.284Z",
    transform: "translate(-222.993 -242.678)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M73.993,303.924c-5.6-4.065-5.728-11.258-2.075-16.284s10.79-8.676,20.263-8.75c2.857,9.032,1.477,17.108-2.06,21.976-3.652,5.027-10.533,7.123-16.128,3.058Z",
    transform: "translate(-56.91 -242.678)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M5.842,134.311c2.137-6.578,8.936-8.926,14.846-7.006s11.586,7.581,14.584,16.568c-7.708,5.508-15.813,6.691-21.536,4.832-5.909-1.92-10.03-7.815-7.892-14.394Z",
    transform: "translate(0 -107.659)",
    fill: "none",
    stroke: "#b9b1b4",
    strokeMiterlimit: 22.926,
    strokeWidth: 1,
    fillRule: "evenodd"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOrigamiFlower);
export default __webpack_public_path__ + "static/media/origami-flower.01245245c82f0d44b752414c712acdbc.svg";
export { ForwardRef as ReactComponent };